// Escape any special characters in the keywords so regex matching works
function escapeForRegex(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function checkMessageKeywordMatch(
  message: string,
  keywords: string[],
): boolean {
  const keywordMatchers = keywords.map((keyword) => {
    const escapedKeyword = escapeForRegex(keyword);

    // \\b word bounds don't work when token includes non-word characters like ! or $
    // use lookaheads that escape a non-word character or start/end of match string
    return `(?<![\\w+])${escapedKeyword}(?![\\w+])`;
  });
  const boundedKeywordRegex = new RegExp(`${keywordMatchers.join(".*")}`, "i");

  return boundedKeywordRegex.test(message);
}
